import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, XCircle } from "lucide-react";
import usePageMeta from "@/lib/usePageMeta";

export default function PaymentCancel() {
  usePageMeta({
    title: "Checkout cancelled | CV AI PRO",
    description: "Your checkout was cancelled — no charge was made.",
    path: "/payment/cancel",
  });

  return (
    <div className="relative min-h-screen bg-black text-white" data-testid="payment-cancel-page">
      <div aria-hidden className="absolute inset-0 grid-bg" />
      <div className="relative mx-auto max-w-2xl px-4 sm:px-6 lg:px-8 pt-32 sm:pt-40 pb-24 text-center">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-zinc-500/15 border border-white/10"
        >
          <XCircle className="h-8 w-8 text-zinc-400" />
        </motion.div>
        <motion.h1
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.6 }}
          className="mt-8 text-3xl sm:text-4xl font-semibold tracking-tighter text-white text-balance"
          data-testid="payment-cancel-headline"
        >
          Checkout cancelled.
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.18, duration: 0.6 }}
          className="mt-5 max-w-xl mx-auto text-zinc-400 text-balance"
        >
          No charge was made. Whenever you're ready, your AI-optimized resume is
          one click away.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.28, duration: 0.6 }}
          className="mt-10"
        >
          <Link
            to="/#pricing"
            className="inline-flex items-center gap-2 rounded-full bg-white text-black px-6 py-3 text-sm font-medium hover:bg-zinc-200 transition-colors"
            data-testid="payment-cancel-back"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to pricing
          </Link>
        </motion.div>
      </div>
    </div>
  );
}
